
import React, { useState } from 'react';
import { Container, TextField, Button, Typography, Box, Modal } from '@mui/material';
import { checkEmail, confirmPhoneNumber, resetPassword } from './api';
import { Link } from 'react-router-dom';
const ForgetPass = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [parentId, setParentId] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = await checkEmail(email);
      setParentId(data.parent_id);
      setStep(2);
    } catch (error) {
      setError(error.error);
    }
  };

  const handlePhoneSubmit = async (e) => {
    e.preventDefault();
    try {
      await confirmPhoneNumber(parentId, phoneNumber);
      setStep(3);
    } catch (error) {
      setError(error.error);
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    try {
      await resetPassword(parentId, newPassword, confirmPassword);
      setStep(4);
    } catch (error) {
      setError(error.error);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box mt={5} p={3} boxShadow={3}>
        {step === 1 && (
          <>
            <Typography variant="h5" gutterBottom>Forget Password</Typography>
            <form onSubmit={handleEmailSubmit}>
              <TextField
                label="Email"
                fullWidth
                margin="normal"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              {error && <Typography color="error">{error}</Typography>}
              <Button type="submit" variant="contained" color="primary">Next</Button>
            </form>
          </>
        )}
        {step === 2 && (
          <>
            <Typography variant="h5" gutterBottom>Confirm Phone Number</Typography>
            <Typography variant="h9" gutterBottom>make sure u write the phone number with +92 and thats the number at the time of registration</Typography>
            <form onSubmit={handlePhoneSubmit}>
              <TextField
                label="Phone Number"
                fullWidth
                margin="normal"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                required
              />
              {error && <Typography color="error">{error}</Typography>}
              <Button type="submit" variant="contained" color="primary">Next</Button>
            </form>
          </>
        )}
        {step === 3 && (
          <>
            <Typography variant="h5" gutterBottom>Reset Password</Typography>
            <form onSubmit={handlePasswordSubmit}>
              <TextField
                label="New Password"
                type="password"
                fullWidth
                margin="normal"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <TextField
                label="Confirm Password"
                type="password"
                fullWidth
                margin="normal"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              {error && <Typography color="error">{error}</Typography>}
              <Button type="submit" variant="contained" color="primary">Reset Password</Button>
            </form>
          </>
        )}
        {step === 4 && (
          <>
            <Typography variant="h5" gutterBottom>Password Reset Successful</Typography>
            <Button variant="contained" color="primary" ><Link to="/login">login</Link></Button>
          </>
        )}
      </Box>
    </Container>
  );
};

export default ForgetPass;
